import { Upload } from "antd";
import { useState } from "react";
import styled from "styled-components";

// Internal Imports
import { COLORS } from "../../constants/colors";
import Modal from "../Modal/Modal";


interface Props {
    value: string;
    onChange: any;
}

const InputWrapper = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${COLORS.white_color2(1)};
    border-radius: 5px;
    border: 1px solid ${COLORS.black_text_color3};
    height: 38px;
    padding-left: 8px;
    
     label {
        color: ${props => !!props.value ? COLORS.black_text_color1 : COLORS.black_text_color3};
        font-weight: 300;
        opacity: ${props => !!props.value ? 1 : 0.5};
        font-size: 1.05em;
    }

    .group-icon {
        position: relative;
        right: -1px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 38px;
        border-left: 1px solid ${COLORS.black_back_color5};
    }

    .icon-remove {
        background-color: ${COLORS.red_error2};
        height: 37px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        color: white;
        width: 33px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .icon-remove:active {
        opacity: 0.7;
    }

   .icon-uploadImg .ant-upload.ant-upload-select-picture-card, .icon-uploadImg .ant-upload-list{
        background-color: ${COLORS.blue_active};
        height: 37px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        width: 33px;
        border: none     
   }

   .icon-uploadImg i {
       color: white;
   }


     .icon-see {
        background-color: white;
        height: 36px;
        color: ${COLORS.blue_active};
        width: 33px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .icon-see:active {
        opacity: 0.7;
    }
`;

const InputImage = ({ value, onChange }: Props) => {

    // States
    const [modalVisible, setModalVisible] = useState<boolean>(false);

    // methods
    const getBase64 = (file: any) => {
        if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif') {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => onChange(reader.result as string);
            reader.onerror = error => console.log(error);
        }
        else {
            onChange('');
        }
    };

    const removePhoto = () => {
        onChange('');
    }

    return (
        <InputWrapper value={(!!value).toString()}>
            <label>{!!value ? "Foto seleccionada" : "Elegir archivo"}</label>
            <div className="group-icon">

                {!!value
                    ? (<>
                        <nav className="icon-see" onClick={() => setModalVisible(true)}><i className="fa-solid fa-eye"></i></nav>
                        <nav className="icon-remove" onClick={() => removePhoto()}><i className="fa-solid fa-xmark"></i></nav>
                    </>)
                    : (<nav>
                        <Upload
                            listType="picture-card"
                            fileList={[]}
                            beforeUpload={getBase64}
                            className="icon-uploadImg"
                        >
                            <i className="fa-solid fa-upload"></i>
                        </Upload>

                    </nav>
                    )

                }
                <Modal props={{ style: { top: '-10px' } }} width={'40%'} title={"Foto Seleccionada"} visible={modalVisible} setVisible={setModalVisible} askBeforeClose={false}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {value
                            ? <img src={value} alt="Foto Perfil" width={"50%"} height={"50%"} />
                            : <h1>Foto no seleccionada</h1>
                        }
                    </div>
                </Modal>
            </div>


        </InputWrapper>
    );
}

export default InputImage;